
import { defineComponent, PropType } from 'vue'

// Components
import PanelSection from '@/components/PanelSection.vue'
import UnitSelect from '@/metrics/UnitSelect.vue'

// Misc
import { tableFuncItems, GaugeColumn } from '@/metrics/types'
import { requiredRule } from '@/util/validation'

export default defineComponent({
  name: 'GaugeColumnOptionsForm',
  components: { PanelSection, UnitSelect },

  props: {
    column: {
      type: Object as PropType<GaugeColumn>,
      required: true,
    },
  },

  setup(props) {
    const rules = { aggFunc: [requiredRule] }
    return { rules, tableFuncItems }
  },
})
